import React from 'react'
import { getUrl, getDescText, getDateAnnouncedShort } from '../../common/services/builders'
import entriesReducer from '../../common/services/reducers/entries';

function MemberListSearchItem({ entry, settings }) {

    return (
        <div className="search-result">
            <div className="row">
                <div className="small-6 column">
                    <span className="category--tag">{entry.industryGroup}</span>
                    
                </div>
                <div className="small-6 column text-right">
                    <span className="category--tag">{entry.country}</span>
                </div>
            </div>

            <div className="row column">
                <h4>{entry.displayName}</h4>

            </div>
        </div>
    )
    
}



function renderTypeTag(entry){
    if(entry.sys.dataFormat == 'webpage'){
        return <span className="category--tag">Webpage</span>
    }
    else{
        return <span className="category--tag">{entry.sys.contentTypeId.split(/(?=[A-Z])/).join(" ")}</span>
    }
}

export default MemberListSearchItem;